<template>
    <div class="container">
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row col-md-12 mt-5">
            <div class="col-md-3 d-flex justify-content-end align-items-center">
                <h4>{{ labels.fechaIni }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <input type="month" v-model="fechaIni" class="form-control" style="width: 180px;">
            </div>
            <div class="col-md-3 d-flex justify-content-end align-items-center">
                <h4>{{ labels.fechaFin }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <input type="month" v-model="fechaFin" class="form-control" style="width: 180px;">
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <b-button type="button" id="create-btn" @click="consulSaldPorContDesdHast">{{ labels.consultar }}</b-button>
        </div>
        <div class="row col-md-12 justify-content-center" v-if="lstRepSaldContrFechaDesHas != 0">
            <div v-if="btnGenExcel" class="row col-md-12 d-flex justify-content-end">
                <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="genReportSaldPorCont()">
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                    </md-icon>
                </md-button>
            </div>
            <b-table
                :items="lstRepSaldContrFechaDesHas"
                hover
                bordered
                responsive
                sticky-header="500px"
                small
                class="tblEstandar"
                head-variant="custom-blue"
                :per-page="perPage"
                :current-page="currentPage"
            >
                <template #cell(nro_contrato)="data">
                    <div class="text-right">{{ data.item.nro_contrato }}</div>
                </template>
                <template #cell(arrendador)="data">
                    <div class="text-left">{{ data.item.arrendador }}</div>
                </template>
                <template #cell(activo_derecho_uso)="data">
                    <div class="text-right">{{ formatNumber(data.item.activo_derecho_uso) }}</div>
                </template>
                <template #cell(amortizacion_acumulada)="data">
                    <div class="text-right">{{ formatNumber(data.item.amortizacion_acumulada) }}</div>
                </template>
                <template #cell(pasivo_final)="data">
                    <div class="text-right">{{ formatNumber(data.item.pasivo_final) }}</div>
                </template>
                <template #cell(patrimonio_neto)="data">
                    <div class="text-right">{{ formatNumber(data.item.patrimonio_neto) }}</div>
                </template>
                <template #cell(pasivo_inicial)="data">
                    <div class="text-right">{{ formatNumber(data.item.pasivo_inicial) }}</div>
                </template>
                <template #cell(pago_capital)="data">
                    <div class="text-right">{{ formatNumber(data.item.pago_capital) }}</div>
                </template>
                <template #cell(gasto_por_amortizacion)="data">
                    <div class="text-right">{{ formatNumber(data.item.gasto_por_amortizacion) }}</div>
                </template>
                <template #cell(gasto_por_intereses)="data">
                    <div class="text-right">{{ formatNumber(data.item.gasto_por_intereses) }}</div>
                </template>
                <template #cell(gasto_canon)="data">
                    <div class="text-right">{{ formatNumber(data.item.gasto_canon) }}</div>
                </template>
                <template #cell(utilidades_acumuladas)="data">
                    <div class="text-right">{{ formatNumber(data.item.utilidades_acumuladas) }}</div>
                </template>
            </b-table>
            <div class="row col-12 mt-1">
                <div class="col-10 d-flex justify-content-center">
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="lstRepSaldContrFechaDesHas.length"
                    :per-page="perPage"
                    align="center"
                    size="md"
                    class="custom-pagination"
                    ></b-pagination>
                </div>
                <div class="col-2 d-flex justify-content-end">
                    <label class="mr-2 mb-0">Filas por página:</label>
                    <b-form-select
                    v-model="perPage"
                    :options="[5, 10, 20, 50, 100, 500]"
                    size="sm"
                    style="width: 80px;"
                    ></b-form-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Reportes from '../../services/Reportes';
import * as XLSX from "exceljs";

export default {
    name : 'SaldosPorContratoDesHas',
    data : () => ({
        fechaIni : '',
        fechaFin : '',
        btnGenExcel : false,
        lstRepSaldContrFechaDesHas : [],
        perPage: 500,
        currentPage: 1,
        // fields: [
        //     { key: 'nro_contrato', label: 'Contrato', sortable: false },
        //     { key: 'arrendador', label: 'Arrendador', sortable: false },
        //     { key: 'activo_derecho_uso', label: 'Activo derecho uso', sortable: false },
        //     { key: 'amortizacion_acumulada', label: 'Amortización acumulada', sortable: false },
        //     { key: 'pasivo_final', label: 'Pasivo final', sortable: false },
        //     { key: 'patrimonio_neto', label: 'Patrimonio neto', sortable: false },
        //     { key: 'pasivo_inicial', label: 'Pasivo inicial', sortable: false },
        //     { key: 'pago_capital', label: 'Pago capital', sortable: false },
        //     { key: 'gasto_por_amortizacion', label: 'Gasto por amortización', sortable: false },
        //     { key: 'gasto_por_intereses', label: 'Gasto por intereses', sortable: false },
        //     { key: 'gasto_canon', label: 'Gasto canon', sortable: false },
        //     { key: 'utilidades_acumuladas', label: 'Utilidades acumuladas', sortable: false },
        // ]
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : 'Saldos por contrato',
                    consultar : 'Consultar',
                    fechaIni : 'Desde',
                    fechaFin : 'Hasta'
                }
            }else{
                return {
                    title : 'Contract balances',
                    consultar : 'Consult',
                    fechaIni : 'From',
                    fechaFin : 'Until'
                }
            }
        }
    },
    methods:{
        consulSaldPorContDesdHast(){
            if(this.fechaIni == '' || this.fechaFin == ''){
                this.$toast.error('Diligenciar la fecha.');
            }else{

                Reportes.generaReportSaldosPorContratFechaDesdHasta(this.fechaIni,this.fechaFin)
                .then((res) => {

                    this.lstRepSaldContrFechaDesHas = res.data.lstSaldPorContrFechDesHas

                    if(this.lstRepSaldContrFechaDesHas.length != 0){
                        this.btnGenExcel = true
                    }else{
                        this.btnGenExcel = false
                        this.$toast.error('No hay datos para la fecha.')
                    }
                })
                .catch((err) => console.log(err))
            }
        },
        async genReportSaldPorCont(){

            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Saldos por contrato")

            const titulo = ["Saldos por contrato"]
            worksheet.addRow(titulo)
            worksheet.mergeCells('A1:L1')
            worksheet.getCell('A1').font = { bold : true, size : 12};
            worksheet.getCell('A1').alignment = { horizontal : 'center'};

            const tituloCelda = [
                'Contrato',
                'Arrendador',
                'Activo derecho de uso',
                'Amortizacion acumulada',
                'Pasivo final',
                'Patrimonio neto',
                'Pasivo inicial',
                'Pago capital',
                'Gasto por amortización',
                'Gasto por intereses',
                'Gasto canon',
                'Utilidades acumuladas'
            ]

            worksheet.addRow(tituloCelda)
            for	(let fila = 1;fila<=2;fila++) {
                worksheet.getRow(fila).font = {
                    name: "Arial Black",
                    family: 2,
                    size: 11,
                    bold: true
                }
            }

            this.lstRepSaldContrFechaDesHas.map((e) => {
                worksheet.addRow([
                    e.nro_contrato,
                    e.arrendador,
                    Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.activo_derecho_uso),
                    Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.amortizacion_acumulada),
                    Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.pasivo_final),
                    Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.patrimonio_neto),
                    Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.pasivo_inicial),
                    Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.pago_capital),
                    Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.gasto_por_amortizacion),
                    Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.gasto_por_intereses),
                    Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.gasto_canon),
                    Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.utilidades_acumuladas)
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }

            for( let row = 1; row <= worksheet.rowCount; row++){
                for( let col = 1; col <= worksheet.columnCount; col++){
                    worksheet.getCell(row, col).border = border;
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Reporte saldos por contrato.xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            downloadLink.remove();

        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(value);
        },
    }
}
</script>

<style src="../main.css">
</style>